import script from "./BtnLang.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnLang.vue?vue&type=script&setup=true&lang=js"

import "./BtnLang.vue?vue&type=style&index=0&id=0a1586a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1586a4"]])

export default __exports__